// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1_zQm","toggleWrap":"styles_toggleWrap__YXA9X","content":"styles_content__3Wju_","selectAreaCode":"styles_selectAreaCode__1iTXf"};